<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m11.8 8.9 3 2.8v-.1q0-1.2-.9-2Q13.1 9 12 9zM8 9.6 9.3 11v.6q0 1 .8 1.9a3 3 0 0 0 2.5.7l1.4 1.4a5 5 0 0 1-5.2-.9 4.4 4.4 0 0 1-.9-5.1m-5-5 2 2 .5.5A11 11 0 0 0 2 11.6a10.7 10.7 0 0 0 14 6l.4.3 2.6 2.6 1.2-1.1L4 3.5m8 3.6q1.9 0 3.2 1.3a4 4 0 0 1 1 4.8l2.7 2.6q2-1.7 3.1-4.2A10.7 10.7 0 0 0 8.4 5.5l2 1.9Q11 7 12 7"
    />
  </svg>
</template>
